import { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { updateCurriculum } from '../../utils/api';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import CourseItem from '../coursesList/courseItem';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { useAuth } from '../../hooks/useAuth';
import { handleDeleteCourse } from '../../utils/helper';
import { useTheme } from '@mui/material/styles';

const CoursePreview = () => {
	let [courseId, setCourseId] = useState<string>('');
	let [courseData, setCourseData] = useState<any>(null);
	let [loading, setLoading] = useState<boolean>(false);
	const location = useLocation();
	const navigate = useNavigate();
	const shouldDeleteCourseRef = useRef<boolean>(true);
	const { authUser } = useAuth();
	const theme = useTheme();

	useEffect(() => {
		if (location?.state?.courseId && location?.state?.courseData) {
			setCourseId(location.state.courseId);
			setCourseData(location.state.courseData);
		} else {
			// navigate(-1);
		}
	}, []); //eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		return () => {
			if (shouldDeleteCourseRef.current) {
				handleDeleteCourse(courseData, authUser);
			}
		};
	}, [courseData]); //eslint-disable-line react-hooks/exhaustive-deps

	const handleSave = async () => {
		setLoading(true);
		shouldDeleteCourseRef.current = false; // Set the flag to false to prevent deletion

		if (courseData) {
			const updatedCourseInfo = {
				...courseData,
				creation_done: true,
			};
			delete updatedCourseInfo.creator_avatar;

			try {
				await updateCurriculum(courseId, updatedCourseInfo, true);
				if (authUser && authUser.userName) {
					navigate(`/${authUser.userName}`);
				} else {
					console.error('Username not available');
				}
			} catch (error) {
				console.error('Error finalizing course creation:', error);
			} finally {
				setLoading(false);
			}
		}
	};

	return (
		<Box pt={0}>
			<div style={{ width: '100%' }}>
				<Box
					display='flex'
					justifyContent='center'
					alignItems='center'
					sx={{
						backgroundColor: (theme) =>
							theme.palette.background['paper-elevation-2'],
						py: 1,
						width: '100%',
					}}
				>
					<Typography variant='h6' sx={{ fontWeight: 'bold' }}>
						Create New Course
					</Typography>
				</Box>
			</div>
			<Box maxWidth='lg' mx='auto' textAlign='left' p={2}>
				<Box pt={2}>
					<Typography variant='h6' color='text.primary' align='left'>
						Preview Course Listing
					</Typography>
					<Typography
						variant='body1'
						color='text.secondary'
						align='left'
						sx={{ mt: 0, mb: 2 }}
					>
						This is how your course will appear to students on the
						search page.
					</Typography>
				</Box>
				<Box
					maxWidth='100%'
					sx={{
						px: 2,
						my: 3,
						py: {
							xs: 0,
							sm: 0,
							md: 3,
						},
						bgcolor: {
							xs: 'transparent',
							sm: 'transparent',
							md: theme.palette.background['paper-elevation-2'],
						},
					}}
				>
					<Box
						sx={(theme) => ({
							display: 'flex',
							justifyContent: 'center',
							backgroundColor: theme.palette.background.default,
							borderRadius: '16px',
							width: {
								xs: '100%',
								sm: '50%',
								md: '33%',
							},
							marginX: 'auto',
							bgcolor: {
								xs: theme.palette.background[
									'paper-elevation-2'
								],
								sm: theme.palette.background[
									'paper-elevation-2'
								],
								md: theme.palette.background.default,
							},
						})}
					>
						{courseData && (
							<CourseItem
								courseItem={courseData}
								handleEnrollCourse={() => {}}
								isEnrolled={false}
								disableButtons={true}
							/>
						)}
					</Box>
				</Box>
				<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
					<Button
						variant='contained'
						color='primary'
						size='large'
						onClick={handleSave}
						disabled={loading}
						startIcon={
							loading ? <CircularProgress size={22} /> : <></>
						}
						sx={{
							width: { xs: '100%', md: 'auto' },
						}}
					>
						{loading ? 'Saving...' : 'Save Course'}
					</Button>
				</Box>
			</Box>
		</Box>
	);
};

export default CoursePreview;
